import { Chart, ChartEvent, PointElement } from 'chart.js'

import { TChartClick } from '../types'

export const handleOnSegmentClick = (params: {
  _active: unknown
  callback: (params: TChartClick) => void
  chart: Chart
  event: ChartEvent
}) => {
  const { callback, chart, event } = params
  const data = chart.data
  const labels = data.labels ?? []

  const native = (event as any)?.native

  if (!native) return

  const rect = chart.canvas.getBoundingClientRect()

  const left = rect.left + native.offsetX + window.scrollX
  const top = rect.top + native.offsetY + window.scrollY

  const hits = chart.getElementsAtEventForMode(
    native,
    'nearest',
    { intersect: true },
    true
  )

  if (!hits.length) return

  const { index, datasetIndex } = hits[0]

  // Optional: ensure we hit a POINT element (not the line)
  const el = chart.getDatasetMeta(datasetIndex).data[index]

  if (!el || !(el instanceof PointElement)) return

  if (!(data.datasets[datasetIndex] as any).main) return

  if (hits.length) {
    const { index, datasetIndex } = hits[0]

    callback({
      datasetIndex,
      datasetLabel: data.datasets?.[datasetIndex].label,
      index,
      label: String(labels[index]),
      position: { left, top },
      value:
        data.datasets?.[datasetIndex].data?.[index] != null
          ? Number(data.datasets[datasetIndex].data[index])
          : undefined
    })

    return
  }
}
